import type { FC } from 'react'

import { Button } from 'common/components/Button/Button'
import { Input } from 'common/components/Input/Input'
import { Select } from 'common/components/Select/Select'
import type { PatientStatus } from 'features/Home/interfaces/IInfoSchedule'
import type { AppointmentCategories } from 'features/Schedule/api/schedule.types'

import styles from './ehrAppointmentV2.module.scss'

type Props = {
  patientName: string
  phone: string
  categoryCode: number | string
  statusCode: number | string
  categories: AppointmentCategories[]
  statuses: PatientStatus[]
  disabled: boolean
  canPickPatient: boolean
  canAddPatient: boolean
  // The Series tab has no status: the Series API does not carry one.
  hideStatus?: boolean
  patientError?: string
  onOpenPatientSearch: () => void
  onAddPatient: () => void
  onCategoryChange: (code: number) => void
  onStatusChange: (code: number) => void
}

export const IdentityRow: FC<Props> = ({
  patientName,
  phone,
  categoryCode,
  statusCode,
  categories,
  statuses,
  disabled,
  canPickPatient,
  canAddPatient,
  hideStatus = false,
  patientError,
  onOpenPatientSearch,
  onAddPatient,
  onCategoryChange,
  onStatusChange,
}) => (
  <div className={styles.band}>
    <div className={`${styles.field} ${styles.widthPatient}`}>
      <Input
        name='patient_selector'
        label='Patient'
        required
        readOnly
        value={patientName}
        placeholder='Click to select'
        onClick={canPickPatient ? onOpenPatientSearch : undefined}
        error={patientError}
      />
    </div>

    <div className={styles.field}>
      <div className={styles.inline}>
        <div className={styles.widthPhone}>
          <Input name='phone_display' label='Cell Phone' value={phone} readOnly />
        </div>
        {canAddPatient && (
          <Button onClick={onAddPatient} disabled={disabled}>
            New patient
          </Button>
        )}
      </div>
    </div>

    <div className={`${styles.field} ${styles.widthCategory}`}>
      <Select
        label='Category'
        required
        value={categoryCode || undefined}
        disabled={disabled}
        showSearch={false}
        options={categories?.map((category) => ({
          value: category.code,
          label: category.name,
        }))}
        onChange={onCategoryChange}
      />
    </div>

    {!hideStatus && (
      <div className={`${styles.field} ${styles.widthStatus}`}>
        <Select
          label='Status'
          value={statusCode === '' ? undefined : statusCode}
          disabled={disabled}
          showSearch={false}
          options={statuses?.map((status) => ({ value: status.code, label: status.name }))}
          onChange={onStatusChange}
        />
      </div>
    )}
  </div>
)
